export const copyToClipboard = async textToCopy => {
  const permissionStatus = await navigator.permissions.query({ name: 'clipboard-write' });
  const allowedStatuses = ['granted', 'prompt'];
  if (allowedStatuses.includes(permissionStatus.state)) {
    await navigator.clipboard.writeText(textToCopy);
  }
};
